"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var csod = require("player-core");
var application_1 = require("../../models/application");
var mapping_1 = require("../../mapping");
var ApplicationActions_1 = require("../../actions/ApplicationActions");
var EmailValidator = require("player-textbox/build/control/EmailValidator");
function view() {
    var _this = this;
    var contactInfoActions = new ApplicationActions_1.ApplicationContactInfoActions(this);
    return {
        state: {
            actionItem: this.props.actionItem,
            isLoggedIn: (csod.context.user > 0) && !csod.viewModel.isPreview,
            reqId: this.props.reqId,
            careerSiteId: this.props.careerSiteId,
            dialogText: "",
            isCancelBtnVisible: true,
            isLoginDialogVisible: false,
            applyWithErrorMessage: "",
            showApplyWithButtons: true,
            isContactInfoFieldEnabled: true,
            invalidEmailErrorMessage: csod.locales.get('ATS.CareerSite.MyProfile.Validation.Email', 'You must enter a valid email address.')
        },
        initialize: function () {
            return new Promise(function (resolve) {
                _this.view.state.isContactInfoFieldEnabled = (!_this.view.state.isLoggedIn && !_this.props.applicationId);
                if (_this.props.displayApplyWithErrorMessage) {
                    var qsParams = ApplicationActions_1.getParams(window.location.search);
                    var errorCode = qsParams["d"];
                    _this.view.state.applyWithErrorMessage = "";
                    if (errorCode) {
                        switch (errorCode) {
                            case "1":
                                _this.view.state.applyWithErrorMessage = _this.props.applyWithAlreadyAssociated;
                                break;
                            case "2":
                                _this.view.state.applyWithErrorMessage = _this.props.applyWithExistingUser;
                                break;
                            case "3":
                                _this.view.state.applyWithErrorMessage = _this.props.applyWithGenericError;
                                break;
                            case "4":
                                _this.view.state.applyWithErrorMessage = _this.props.applyWithAuthenticationError;
                                break;
                            case "5":
                                _this.view.state.applyWithErrorMessage = _this.props.applyWithInactiveUserError;
                                break;
                        }
                    }
                    _this.props.onActionLoaded();
                }
                _this.view.helpers.setApplyWithVisibility();
                resolve();
            });
        },
        mounted: function () {
            _this.view.helpers.returnResultsToPage();
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.state.isContactInfoFieldEnabled = (!_this.view.state.isLoggedIn && !nextProps.applicationId);
            _this.view.helpers.returnResultsToPage();
            _this.view.helpers.setApplyWithVisibility();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onFirstNameChange: function (firstName) {
                contactInfoActions.firstNameChange(firstName);
                return false;
            },
            onLastNameChange: function (lastName) {
                contactInfoActions.lastNameChange(lastName);
                return false;
            },
            onEmailChange: function (email) {
                email = email.trim();
                contactInfoActions.emailChange(email);
                return false;
            },
            onEmailValidate: function () {
                csod.viewModel.isEmailBeingValidated = true;
                if (_this.view.state.actionItem.email.value == '') {
                    csod.viewModel.isEmailBeingValidated = false;
                    return;
                }
                var isEmailValid = EmailValidator.validateEmail(_this.view.state.actionItem.email.value);
                if (isEmailValid) {
                    mapping_1.validateAnonymousEmail(_this.view.state.actionItem.email.value, _this.view.state.reqId)
                        .then(function (data) {
                        if (data.statusCode == 0) {
                            _this.view.state.actionItem.email.errorMessage = "";
                            _this.view.state.isLoginDialogVisible = false;
                            csod.viewModel.isEmailBeingValidated = false;
                        }
                        else if (data.statusCode == 1 || data.statusCode == 4) {
                            _this.view.state.actionItem.email.errorMessage = data.validationMessage;
                            _this.view.state.isLoginDialogVisible = false;
                            csod.viewModel.isEmailBeingValidated = false;
                        }
                        else if (data.statusCode == 2) {
                            _this.view.state.dialogText = data.validationMessage;
                            _this.view.state.isLoginDialogVisible = true;
                            _this.view.state.isCancelBtnVisible = false;
                            csod.viewModel.isEmailBeingValidated = true;
                        }
                        else if (data.statusCode == 3) {
                            _this.view.state.dialogText = data.validationMessage;
                            _this.view.state.isLoginDialogVisible = true;
                            _this.view.state.isCancelBtnVisible = true;
                            csod.viewModel.isEmailBeingValidated = true;
                        }
                        csod.engine.commit();
                    })
                        .catch(function () {
                    });
                }
                else {
                    csod.viewModel.isEmailBeingValidated = false;
                    _this.view.state.actionItem.email.errorMessage = _this.view.state.invalidEmailErrorMessage;
                }
            },
            onContactInfoUpdated: function () {
            },
            onDialogClose: function () {
                _this.view.state.isLoginDialogVisible = false;
                csod.viewModel.isEmailBeingValidated = false;
            },
            onSignInClick: function () {
                var appStartUrl = "" + window.location.pathname + window.location.search;
                appStartUrl = encodeURIComponent(appStartUrl);
                var loginUrl = csod.context.applicationBase + "ats/careersite/login.aspx?site=" + _this.view.state.careerSiteId + "&c=" + csod.context.corp + "&email=" + _this.view.state.actionItem.email.value + "&lang=" + csod.viewModel.cultureName + "&returnurl=" + appStartUrl;
                window.location.replace(loginUrl);
            },
            onApplyWithButtonClicked: function (e, service, index) {
                _this.props.onLoadingChanged(true);
                var params_arr = window.location.search.slice(1).split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    var param = params_arr[i].split("=")[0];
                    if (param === "d" || param === "provider" || param === "socialId") {
                        params_arr.splice(i, 1);
                    }
                }
                var redirectUrl = "" + window.location.origin + window.location.pathname;
                if (params_arr.length > 0 && params_arr[0]) {
                    redirectUrl += "?" + params_arr.join("&");
                }
                var encodedRedirectUrl = encodeURIComponent(redirectUrl);
                mapping_1.getApplyWithAuthUrl(service.providerId, encodedRedirectUrl, _this.view.state.careerSiteId, _this.view.state.reqId)
                    .then(function (data) {
                    window.location.replace(data.authURL);
                })
                    .catch(function (error) {
                    csod.notify.error(_this.props.genericErrorMessage);
                    _this.props.onLoadingChanged(false);
                });
            }
        },
        helpers: {
            returnResultsToPage: function () {
                var resultData = new application_1.ContactInfoResultData();
                resultData.actionId = _this.props.actionItem.id;
                resultData.type = application_1.ActionType.contactInformation;
                resultData.email = _this.view.state.actionItem.email.value;
                resultData.firstName = _this.view.state.actionItem.firstName.value;
                resultData.lastName = _this.view.state.actionItem.lastName.value;
                resultData.appliedWithLinkedIn = csod.viewModel.applyWithLinkedInData.didApplicantApplyWithLinkedIn;
                _this.props.onDataChanged(resultData);
            },
            setApplyWithVisibility: function () {
                if (!_this.view.state.actionItem.services)
                    _this.view.state.showApplyWithButtons = false;
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/ApplicationContactInfo/View.js
// module id = 602
// module chunks = 0